import { SHOP_RETRIEVED } from '../actions'

const getInitialLocale = () => {
  if (typeof window === 'undefined' || !window.localStorage) return 'sv'

  try {
    return window.localStorage.getItem('locale') || 'sv'
  } catch (error) {
    return 'sv'
  }
}

const intl = (state = {
  locale: getInitialLocale(),
  currency: 'SEK',
  messages: {}
}, action) => {
  switch(action.type) {
    case SHOP_RETRIEVED:
      if (action.shop.locale) {
        return Object.assign({}, state, {
          locale: action.shop.locale,
          currency: action.shop.currency,
          messages: action.shop.messages
        })
      }
      return state
    default:
      return state
  }
}

export default intl
